import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import {
  getStoolColor,
  isStool,
  isStoolBloody,
  isStoolMucus,
  isStoolOffensive,
  StoolColormap
} from '../../../../common/utils'

const StoolMark = (color, key) => {
  return (
    <td
      key={key}
      style={{
        backgroundColor: color,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center'
      }}
    >
      <img
        style={{ width: 12, left: -3, position: 'relative' }}
        src="https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/icon-tick.png"
        alt="tick"
      />
    </td>
  )
}

class StoolTable extends Component {
  render() {
    const { logs } = this.props
    const types = [1, 2, 3, 4, 5, 6, 7]
    const logsSorted = _.sortBy(logs, ({ timeLogged }) => -dayjs(timeLogged))
    return (
      <div
        style={{
          marginTop: 42,
          padding: '12px 0px',
          background: colors.white,
          borderRadius: 16
        }}
      >
        <table className="Table ItemList">
          <thead className="lmc-table-center-text">
            <tr className="lmc-table-header">
              <th style={{ width: 180 }}>Date</th>
              <th colSpan="7" style={{ width: 170, textAlign: 'center' }}>
                Bristol Type
              </th>
              <th style={{ width: 57 }}>Blood</th>
              <th style={{ width: 62 }}>Mucus</th>
              <th style={{ width: 81 }}>Offensive</th>
              <th style={{ width: 63 }}>Colour</th>
              <th>Note</th>
              <th>Carer</th>
            </tr>
            <tr className="lmc-table-subheader">
              <th></th>
              {types.map((d) => (
                <th key={d}>{d}</th>
              ))}
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {logsSorted.map((log) => {
              // if anyone sees this, feel free to shout at Sam or Adam.
              // (form data => string => regex => form data) === shame
              const type = _.get(log, 'measurements.stool.value')
              const isBloody = isStoolBloody(log)
              const isMucus = isStoolMucus(log)
              const isOffensive = isStoolOffensive(log)
              const stoolColor = getStoolColor(log)
              const isDeleted = log.deleted

              return (
                <tr key={log.id}>
                  <td style={{ textAlign: 'center' }}>
                    <Link
                      className={!isDeleted && 'lmc-dark-link'}
                      to={`/logs/${log.id}`}
                      style={{ color: colors.grey }}
                    >
                      {dayjs(log.timeLogged).format('HH:mm DD/MM/YY')}
                    </Link>
                  </td>
                  {types.map((t) =>
                    type === t ? (
                      isDeleted ? (
                        <td />
                      ) : (
                        StoolMark(StoolColormap[t], t)
                      )
                    ) : (
                      <td key={t} />
                    )
                  )}
                  {isBloody && !isDeleted ? StoolMark(colors.darkgrey) : <td />}
                  {isMucus && !isDeleted ? StoolMark(colors.darkgrey) : <td />}
                  {isOffensive && !isDeleted ? (
                    StoolMark(colors.darkgrey)
                  ) : (
                    <td />
                  )}
                  <td
                    style={{ textAlign: 'center', textTransform: 'capitalize' }}
                  >
                    {isDeleted ? null : stoolColor}
                  </td>
                  <td
                    style={{
                      textAlign: isDeleted ? 'center' : null,
                      color: isDeleted ? colors.grey : null
                    }}
                  >
                    {isDeleted
                      ? 'Log Removed'
                      : `${isStool(log) ? `` : log.description}`}
                  </td>
                  <td
                    style={{
                      textAlign: 'center',
                      color: isDeleted && colors.grey
                    }}
                  >
                    {log.carerName}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

StoolTable.propTypes = {
  logs: PropTypes.array.isRequired
}

export default StoolTable
